// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aOX3","rootMobile":"styles_rootMobile__2QOpY"};